export const UserRightForbidden = 0;
export const UserRightViewer = 1;
export const UserRightAll = 2;